import { connect } from "react-redux";

import * as statisticsActions from "./actions";

function mapStateToProps(state) {
  return {
    statistics: state.statistics,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchStatistics: (from, to, selectedRangeType, actionTypesToDisplay) => {
      dispatch(
        statisticsActions.fetch_combined_statistics_range(
          from,
          to,
          selectedRangeType,
          actionTypesToDisplay,
        ),
      );
    },
  };
}

export const statisticsConnector = connect(mapStateToProps, mapDispatchToProps);
